<template>
  <Button
    :class="$style.button"
    :loading="loading"
    :disabled="countdown > 0"
    @click="handleClick"
  >
    {{ countdown > 0 ? `${countdown}s 后重试` : "获取验证码" }}
  </Button>
</template>

<script>
import { getSendCode, getCode, getForgetPwdCode, smsSend } from "@server";
import { validPhone } from "@utils";

export default {
  name: "CaptchaButton",
  props: {
    sendByPhone: {
      // true - 按手机号发送， false - 不用手机号发送
      type: Boolean,
      default: false,
    },
    phone: {
      type: String,
      default: "",
    },
    email: {
      type: String,
      default: "",
    },
    sendByCode: {
      type: Boolean,
      default: false,
    },
    code: {
      type: String,
      default: "",
    },
    checkType: {
      // 验证类型: 0=手机, 1=邮箱 (可选，使用smsSend)
      type: Number,
      default: undefined,
    },
    beforeSend: {
      type: Function,
      default: () => true,
    },
  },
  data() {
    return {
      countdown: 0,
      loading: false,
    };
  },
  methods: {
    startCountdown() {
      this.countdown = 60;
      this.timer = setInterval(() => {
        this.countdown--;

        if (this.countdown === 0) {
          clearInterval(this.timer);
          this.timer = null;
          this.$emit("finish");
        }
      }, 1000);
    },

    checkInput() {
      // checkType模式：通过token发送，不需要前端校验
      if (this.checkType !== undefined) return true;
      // sendByCode模式：使用forget密码verify code，不需要前端校验
      if (this.sendByCode) return true;

      // sendByPhone模式：校验手机号
      if (this.sendByPhone) {
        if (!validPhone(this.phone)) {
          this.$message({
            message: `请输入${this.phone && "正确的"}手机号`,
            type: "warning",
          });
          return false;
        }
        return true;
      }

      // 默认模式：不需要校验
      return true;
    },

    async handleClick() {
      if (!this.beforeSend()) return;
      if (!this.checkInput()) return;

      this.loading = true;

      let res;

      if (this.checkType !== undefined) {
        res = await smsSend(this.checkType);
      } else if (this.sendByPhone) {
        res = await getCode(this.phone);
      } else if (this.sendByCode) {
        res = await getForgetPwdCode(this.code);
      } else {
        res = await getSendCode();
      }

      if (res?.code === 200) {
        this.$message({
          message: "验证码已经发送，请注意查收!",
          type: "success",
        });
        this.startCountdown();
      }
      this.loading = false;
    },

    reset() {
      this.countdown = 0;
      this.loading = false;
      this.timer && clearInterval(this.timer);
    },
  },
  beforeDestroy() {
    this.reset();
  },
};
</script>

<style lang="scss" module scoped>
.button {
  margin: 0;
  margin-left: rem(20) !important;
  color: $theme-color;
  background: $white;
  border: 1px solid $theme-color;
  border-radius: rem(5);
  transition: 0.24s;

  &:hover {
    background: #feede8;
  }
}

:global {
  .gl-button {
    &.gl-button--disabled {
      color: $white;
      background-color: #777;
      border-color: #777;

      &:hover {
        background: #777;
      }
    }
  }
}
</style>